import * as React from "react";
import {createElement} from "react";

export const gs = 3;
